import { render, staticRenderFns } from "./teacher-schedule-view.vue?vue&type=template&id=4fbb7883&scoped=true&"
import script from "./teacher-schedule-view.vue?vue&type=script&lang=js&"
export * from "./teacher-schedule-view.vue?vue&type=script&lang=js&"
import style0 from "./teacher-schedule-view.vue?vue&type=style&index=0&id=4fbb7883&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbb7883",
  null
  
)

export default component.exports